module.exports = __webpack_public_path__ + "img/sp_menu_travel.77257d70.svg";